export enum InterpreterSelectionEnum {
  NO_INTERPRETER = 'NO_INTERPRETER',
  GETTING_HELP_OF_INTERPRETER = 'GETTING_HELP_OF_INTERPRETER',
}

export const InterpreterSelectionLabels = {
  [InterpreterSelectionEnum.NO_INTERPRETER]: 'I did not use a preparer and/or translator',
  [InterpreterSelectionEnum.GETTING_HELP_OF_INTERPRETER]:
    'A preparer(s) and/or translator(s) assisted the employee in completing Section 1',
};
